import { Routes } from '@angular/router';
import { AuthGuard } from './guard/auth/auth.guard';


export const routes: Routes = [
  // {
  //   path: 'home',
  //   loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
  //   canLoad: [AuthGuard],
  // },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'tabs',
    loadChildren: () => import('./tabs/tabs.routes').then( m => m.tabsRoutes),
    canLoad: [AuthGuard],
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.routes').then( m => m.dashboardRoutes),
    canLoad: [AuthGuard],
  },
  {
    path: 'dashboard2',
    loadChildren: () => import('./pages/dashboard2/dashboard2.routes').then( m => m.routes),
    canLoad: [AuthGuard],
  },
  {
    path: 'vendors',
    loadChildren: () => import('./pages/vendors/vendors.routes').then( m => m.vendorsRoutes),
    canLoad: [AuthGuard],
  },
  {
    path: 'vendor',
    loadComponent: () => import('./pages/store/store.page').then( m => m.StorePage)
  },
  {
    path: 'vendor-users',
    loadComponent: () => import('./pages/vendor-users/vendor-users.page').then( m => m.VendorUsersPage),
    canLoad: [AuthGuard],
  },
  {
    path: 'clients',
    loadComponent: () => import('./pages/clients/clients.page').then( m => m.ClientsPage),
    canLoad: [AuthGuard],
  },
  {
    path: 'products',
    loadChildren: () => import('./pages/products/products.routes').then( m => m.productsRoutes),
    canLoad: [AuthGuard],
  },
  {
    path: 'orders',
    loadChildren: () => import('./pages/orders/orders.routes').then( m => m.ordersRoutes),
    canLoad: [AuthGuard],
  },
  
  {
    path: 'services',
    loadComponent: () => import('./pages/services/services.page').then( m => m.ServicesPage),
    canLoad: [AuthGuard],
  },
  {
    path: 'reports',
    loadComponent: () => import('./pages/reports/reports.page').then( m => m.ReportsPage),
    canLoad: [AuthGuard],
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then( m => m.LoginPage),
    canLoad: [AuthGuard],
  },
 
];
